import { Resource } from "../resource"

export type AnalyticsEventName =
  | "openPage"
  | "addToCard"
  | "addToCart"
  | "zoomedImage"
  | "page_view"
  | "view_item"
  | "view_item_list"
  | "select_item"
  | "search"
  | "add_to_cart"
  | "remove_from_cart"
  | "add_to_wishlist"
  | "begin_checkout"
  | "add_shipping_info"
  | "add_payment_info"
  | "purchase"
  | "login"
  | "sign_up"

export class AnalyticsItem extends Resource {
  itemId: string
  itemName: string
  itemBrand: string
  itemCategory: string
  itemVariant: string
  sku: string
  price: number
  quantity: number
  index: number
}

export class AnalyticsEvent extends Resource {
  name: AnalyticsEventName
  eventId: string
  pagePath: string
  pageTitle: string
  searchTerm: string
  method: string
  currency: string
  value: number
  transactionId: string
  coupon: string
  shipping: number
  tax: number
  items: AnalyticsItem[]
  params: any
  clientId: string
}
